import React, { useState, useContext, useEffect } from "react";
import { UserContext } from "shared/context/UserContext";
import IgnoreOptions from "./IgnoreOptions";
import { Row, Col, Container, Form, Button } from "react-bootstrap";
import SingleSelectDropdown from "../../../components/SingleSelectDropdown";
import { useIgnoreClaimApi } from "./hooks/useIgnoreClaimApi";
import { useIgnorePaymentsApi } from "./hooks/useIgnorePaymentsApi";
import KendoDropdown from "../../../components/form/KendoDropdown";

import { ControlSpinner } from "shared/components/spinners/ControlSpinner";

export function IgnoreBody(props) {
  const {
    selectedNcpdpIgnoreModalText,
    selectedRxIgnoreModalText,
    selectedClidsToIgnore,
    handleCancelClick,
    isCancelButtonHidden = false,
    onSaveButtonClickCallbackFromParent = null,
    onSuccessCallbackFromParent = null,
    disableControls = false,
    tabName = null
  } = props;

  const userContext = useContext(UserContext);
  let user = userContext.email;

  //NOTE: I think we can probably simplify this by just retrieving the ignoreNote on submission?
  const [ignoreReason, setIgnoreReason] = useState();
  const [ignoreNote, setIgnoreNote] = useState("");
  const [ignoreClaimsApiParameters, setIgnoreClaimsApiParameters] = useState({});
  const [ignorePaymentsApiParameters, setIgnorePaymentsApiParameters] = useState({});

  let { data: hookCall, isError, error: ignoreClaimsHookError } = useIgnoreClaimApi(
    ignoreClaimsApiParameters,
    onSuccessCallbackFromParent
  );

  let { error: ignorePaymentsHookError } = useIgnorePaymentsApi(
    ignorePaymentsApiParameters,
    onSuccessCallbackFromParent
  );
  
  const handleSaveIgnoreClick = () => {
    if (!ignoreReason) {
      alert("Please select an ignore reason.");
      // return;
    }
    else {
      let parameters = {
        user: user,
        IgnoreId: ignoreReason.value.toString(),
        IgnoreNote: ignoreNote,
      };

      if (tabName === "UnappliedCash") {
        //NOTE TODO: This parameter is just misnamed
        parameters.PaymentIds = selectedClidsToIgnore.toString();
        setIgnorePaymentsApiParameters(parameters);
      }
      else {
        parameters.ClaimIds = selectedClidsToIgnore.toString();

        setIgnoreClaimsApiParameters(parameters);
      }

      if (onSaveButtonClickCallbackFromParent) {
        onSaveButtonClickCallbackFromParent();
      }
    }

  };

  const handleCancelAfterErrorClick = () => {
    ignoreClaimsHookError = null;
    if (handleCancelClick) {
      handleCancelClick();
    }
  };


  if (ignoreClaimsHookError) {
    return <div><div>
      Error: {ignoreClaimsHookError && ignoreClaimsHookError.message && ignoreClaimsHookError.message.includes("408") ? "Your request has timed out, please try again later." : ignoreClaimsHookError}
    </div>
      <div>
        Click the button key below to dismiss.
      </div>
      <Button variant="secondary" onClick={handleCancelAfterErrorClick}>
        Close
      </Button>
    </div>
  }
  else if (ignorePaymentsHookError) {
    return <div><div>
      Error: {ignorePaymentsHookError && ignorePaymentsHookError.message && ignorePaymentsHookError.message.includes("408") ? "Your request has timed out, please try again later." : ignorePaymentsHookError}
    </div>
      <div>
        Click the button key below to dismiss.
      </div>
      <Button variant="secondary" onClick={handleCancelAfterErrorClick}>
        Close
      </Button>
    </div>
  }
  else {

    return (
      disableControls ?
        <ControlSpinner /> :
        <Container>
          <Row>
            <Col> NCPDP </Col>
            <Col> Rx #</Col>
          </Row>
          <Row>
            <Col>{selectedNcpdpIgnoreModalText}</Col>
            <Col>{selectedRxIgnoreModalText}</Col>
          </Row>
          <br />
          <Row>
            <Col> Ignore Code </Col>
          </Row>
          <Row>
            <Col>

              <KendoDropdown
                dataSource={IgnoreOptions || []}
                textField="label"
                idField="value"
                value={ignoreReason}
                sortBy="asc"
                onChange={(e) => {
                  if (e !== null) {
                    setIgnoreReason(e);
                  } else {
                    setIgnoreReason(null);
                  }
                }}
              />

            </Col>
          </Row>
          <br />
          <Row md={1}>
            <Col>
              <Form.Group controlId="txtIgnoreNote">
                <Form.Label> Comments </Form.Label>
                <Form.Control
                  as="textarea"
                  rows="5"
                  value={ignoreNote}
                  placeholder="Type your message here..."
                  onChange={(event) => {
                    setIgnoreNote(event.target.value);
                  }}
                >
                  {" "}
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
          <br />
          <Row>
            {isCancelButtonHidden ? null : (
              <Col>
                <Button variant="secondary" onClick={handleCancelClick}>
                  Cancel
                </Button>
              </Col>
            )}
            <Col>
              <Button className="primary-button" onClick={handleSaveIgnoreClick}>
                Save
              </Button>
            </Col>
          </Row>
        </Container>

    );

  }
}
